import BaseStyles from '@axa-japan/design-system-react/BaseStyles';
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import AppInitializer from './AppInitializer.tsx';
import './index.css';
import { queryClient } from './libs/queryClient.tsx';
import ApplicationProvider from './providers/ApplicationProvider.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BaseStyles>
        <ApplicationProvider>
          <AppInitializer />
        </ApplicationProvider>
      </BaseStyles>
    </QueryClientProvider>
  </StrictMode>,
);
